'use strict';

/**
 * @module views/markers/_
 * @author Sebastian Pekarek
 */

//const ConfigurationHelper = require('../../helpers/configuration');
const EventHelper = require('../../helpers/event');

class Marker {
	constructor (options) {
		this.type = options.type;
		this.map = options.map;
		this.object = options.object;
		this.debugColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);

		const customMarker = null;//ConfigurationHelper.getCustomMarkerConfig(this.type);
		this.marker = this[customMarker ? 'renderCustomMarker' : 'renderMarker'](customMarker);
	}

	renderCustomMarker (marker) {
		return new google.maps.Marker({
			clickable: true,
			zIndex: 20,
			cursor: 'pointer',
			icon: {
				anchor: new google.maps.Point(marker.anchor[0], marker.anchor[1]),
				size: new google.maps.Size(marker.size[0], marker.size[1]),
				scaledSize: marker.scaledSize ? new google.maps.Size(marker.scaledSize[0], marker.scaledSize[1]) : null,
				url: marker.file
			},
			map: this.map.map,
			optimized: false,
			infoWindow: null,
			position: new google.maps.LatLng(this.object.lat, this.object.lng),
			title: this.object.name
		});
	}

	remove () {
		['bounds', 'marker'].forEach(object => {
			if (this[object]) {
				this[object].setMap(null);
				google.maps.event.clearInstanceListeners(this[object]);
			}
		});
		
		EventHelper.removeListeners(this);
		delete this;
	}
}

module.exports = Marker;
